import { createFileRoute } from '@tanstack/react-router';
import CreatePassword from 'containers/Login/CreatePassword';
import { AppLoader } from '../-components/AppLoader';

export const Route = createFileRoute('/login/createPassword')({
  pendingComponent: AppLoader,
  component: CreatePassword,
});
